// src/constants.ts
var COUNTDOWN_SECONDS = 8;
var LOADING_TIMEOUT = 2e3;

export { COUNTDOWN_SECONDS, LOADING_TIMEOUT };
//# sourceMappingURL=chunk-QUILORVR.mjs.map
//# sourceMappingURL=chunk-QUILORVR.mjs.map